import { render, staticRenderFns } from "./CreatePicklPage.vue?vue&type=template&id=8a0c9332&scoped=true&"
import script from "./CreatePicklPage.vue?vue&type=script&lang=ts&"
export * from "./CreatePicklPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePicklPage.vue?vue&type=style&index=0&id=8a0c9332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0c9332",
  null
  
)

export default component.exports